import React from 'react';

interface TimeRangePickerProps {
  startTime: string;
  endTime: string;
  onStartChange: (time: string) => void;
  onEndChange: (time: string) => void;
  error?: string;
}

// Generate time options every 30 minutes
const generateTimeOptions = (): string[] => {
  const options: string[] = [];
  for (let hour = 0; hour < 24; hour++) {
    options.push(`${hour.toString().padStart(2, '0')}:00`);
    options.push(`${hour.toString().padStart(2, '0')}:30`);
  }
  return options;
};

const TimeRangePicker: React.FC<TimeRangePickerProps> = ({
  startTime,
  endTime,
  onStartChange,
  onEndChange,
  error,
}) => {
  const timeOptions = generateTimeOptions();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div style={{ flex: 1 }}>
          <label
            style={{
              display: 'block',
              fontSize: 13,
              color: '#B0BEC5',
              marginBottom: 6,
              fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
            }}
          >
            Desde
          </label>
          <select
            value={startTime}
            onChange={(e) => onStartChange(e.target.value)}
            style={{
              width: '100%',
              height: 44,
              padding: '0 12px',
              backgroundColor: '#181A1B',
              border: '1px solid #33383B',
              borderRadius: 10,
              color: '#FFFFFF',
              fontSize: 14,
              fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
              cursor: 'pointer',
            }}
          >
            {timeOptions.map((time) => (
              <option key={time} value={time}>
                {time}
              </option>
            ))}
          </select>
        </div>

        <div style={{ flex: 1 }}>
          <label
            style={{
              display: 'block',
              fontSize: 13,
              color: '#B0BEC5',
              marginBottom: 6,
              fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
            }}
          >
            Hasta
          </label>
          <select
            value={endTime}
            onChange={(e) => onEndChange(e.target.value)}
            style={{
              width: '100%',
              height: 44,
              padding: '0 12px',
              backgroundColor: '#181A1B',
              border: '1px solid #33383B',
              borderRadius: 10,
              color: '#FFFFFF',
              fontSize: 14,
              fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
              cursor: 'pointer',
            }}
          >
            {timeOptions.map((time) => (
              <option key={time} value={time}>
                {time}
              </option>
            ))}
          </select>
        </div>
      </div>

      {error && (
        <div
          style={{
            fontSize: 12,
            color: '#FF5252',
            fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default TimeRangePicker;
